// extracted by mini-css-extract-plugin
export default {"active_tab":"styles_active_tab__XETaB","mobile_view":"styles_mobile_view__uGVEI"};